exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._107oe4ZASY431q{margin:10px 0 0}._3bTQ6o9FGX-JMG{margin:0 4px 5px}._1zsA1NHze3_bvl{border-radius:3px;color:#5e6c84;display:block;float:left;height:20px;font-size:16px;font-weight:700;line-height:20px;padding:10px 10px 10px 36px;position:relative;text-align:center}._1zsA1NHze3_bvl:hover{background-color:#dfe1e6;color:#172b4d}._9Va-yAzdy_0oN{position:absolute;top:5px;left:5px}._3WbMJMgB2ZAGoJ{border-radius:3px;display:block;float:left;height:30px;padding:5px 8px;text-align:center}._3WbMJMgB2ZAGoJ:hover{background-color:#dfe1e6}", ""]);

// exports
exports.locals = {
	"footerLinks": "_107oe4ZASY431q",
	"footerMessage": "_3bTQ6o9FGX-JMG",
	"blogLink": "_1zsA1NHze3_bvl",
	"blogIcon": "_9Va-yAzdy_0oN",
	"socialMediaLink": "_3WbMJMgB2ZAGoJ"
};